import type { ExpandList } from '@jira/platform__rest-page/src/page.tsx';

export const EXPAND_PARAMETERS: ExpandList = [
	'owner',
	'favourite',
	'favouritedCount',
	'sharePermissions',
	'editPermissions',
	'description',
	'isWritable',
	'systemDashboard',
];
